import { SQUARE_LOGO } from '../../../../fields'
import { getImageAssetInitialValues } from '../../helpers'

export const getInitialValues = assets => {
  return {
    [SQUARE_LOGO]: assets.map(asset => getImageAssetInitialValues(asset))
  }
}
